import React, { Component } from 'react'
import styled from 'styled-components'

import { distance } from '../../layouts/functions'

import IconPlace from '../../assets/icons/place.svg'

const PlaceCardContentStyle = styled.div`
  position: absolute;
  padding: 20px;
  z-index: 99999;
  height: calc(100% - 40px);
  width: calc(100% - 40px);
  display: flex;
  align-content: space-between;
  flex-wrap: wrap;

  .placeCardContentTitle {
    h2 {
      color: white;
      margin-bottom: 4px;
    }
  
    h5 {
      color: white;
    }
  }

  .placeCardContentExtra {
    display: flex;
    width: 100%;
    justify-content: space-between;

    .placeCardContentExtraLocation {
      display: flex;
      align-items: center;

      img {
        width: 26px;
      }

      h5 {
        color: white;
        margin-left: 5px;
      }
    }
  }
`;

export default class PlaceCardContent extends Component {
  _isMounted = false;

  state= {
    userPositionLatitude: 0,
    userPositionLongitude: 0,
    distanceFromYou: undefined
  }

  componentDidMount() {
    this._isMounted = true;

    let latitudeTemp = 0;
    let longitudeTemp = 0;
    let distanceFromYouTemp = undefined;
    let my = this;

    if (typeof window !== `undefined` && this._isMounted) {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(function(position) {
          latitudeTemp = position.coords.latitude;
          longitudeTemp = position.coords.longitude;
  
          my.setState({
            userPositionLatitude: latitudeTemp,
            userPositionLongitude: longitudeTemp
          })
  
          distanceFromYouTemp = distance(my.state.userPositionLatitude, my.state.userPositionLongitude, my.props.placeInfo.frontmatter.latitude, my.props.placeInfo.frontmatter.longitude, 'K')
  
          distanceFromYouTemp = distanceFromYouTemp.toFixed(1)
  
          my.setState({
            distanceFromYou: `${distanceFromYouTemp} km da te`
          })
  
        }, function() {
          my.setState({
            distanceFromYou: 'GPS disabilitato'
          })
        });
      } else {
        console.log('Geolocation is not supported for this Browser/OS.');
      }
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { placeInfo } = this.props;

    return (
      <PlaceCardContentStyle>
        <div className="placeCardContentTitle">
          <h2>{placeInfo.frontmatter.name}</h2>
          <h5>{placeInfo.frontmatter.type}</h5>
        </div>
        <div className="placeCardContentExtra">
          <div className="placeCardContentExtraLocation">
            <img src={IconPlace} alt=""/>
            <h5>{this.state.distanceFromYou !== undefined ? this.state.distanceFromYou : 'Caricando...'}</h5>
          </div>
        </div>
      </PlaceCardContentStyle>
    )
  }
}
